module.exports = __webpack_public_path__ + "static/img/cover_tips_2.5ca232d4.png";